<template>
  <v-container>
    <v-layout row>
      <v-flex xs10>
        <v-autocomplete
          :key="volumesKey"
          ref="volumeInput"
          v-model="currentVolume"
          :items="items"
          :search-input.sync="search"
          item-title="name"
          item-value="_id"
          @keyup.enter="_updateCurrentVolume"
          label="Volume para embarcar"
        >
          <template v-slot:selection="{ props, item }">
            <div>{{ item.name }}</div>
          </template>
          <template v-slot:item="{ props, item }">
            <div>{{ item.name }}</div>
          </template>
        </v-autocomplete>
      </v-flex>
      <v-flex xs2>
        <v-btn
          top
          :disabled="!currentVolume"
          color="primary"
          small
          :loading="loading"
          @click="_shipVolume"
        >
          Embarcar Volume
        </v-btn>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  props: {
    volumeToShip: { type: String }
  },
  data: () => ({
    loading: false,
    items: [],
    search: null,
    currentVolume: null,
    piecesToPack: [],
    volumesKey: new Date().toISOString()
  }),

  mounted() {
    const piecesToPackInput = this.$refs.volumeInput;
    piecesToPackInput.focus();
    this.getVolumesToShip();
  },
  computed: {
    ...mapState({
      volumes: (state) => state.volume.volumes
    })
  },
  methods: {
    ...mapActions({
      _listVolumes: 'listVolumes',
      _ship: 'shipVolume'
    }),
    async _shipVolume() {
      try {
        this.loading = true;
        const filtered = this.volumes.filter(
          (volume) => volume['_id'] === this.currentVolume
        );

        if (filtered.length > 0) {
          await this._ship(filtered[0]);
        }
        this.currentVolume = null;
        await this._listVolumes(this.$route.params.id);
      } catch (e) {
        console.log(e);
        this.snackbarText =
          'Ocorreu um erro tentando embarcar o volume. Tente novamente.';
        this.showSnackbar = true;
      }
      this.loading = false;
    },
    getVolumesToShip() {
      this.items =
        this.volumes.filter((volume) => volume.status === 'CREATED') || [];
    },
    async _updateCurrentVolume(e) {
      if (this.currentVolume) {
        await this._shipVolume();
      }
    },
    querySelections(v) {
      const paddedSearch = String(v || '').padStart(4, '0');
      this.items = this.volumes.filter((volume) =>
        String(volume.volumeId).padStart(4, '0').startsWith(paddedSearch)
      );
      const exact = this.volumes.filter(
        (volume) => String(volume.volumeId).padStart(4, '0') === paddedSearch
      );

      for (const volume of exact) {
        if (volume.status === 'CREATED') {
          this.currentVolume = volume._id;
        }
      }
    }
  },
  watch: {
    volumeToShip(newValue) {
      if (newValue) {
        this.currentVolume = newValue;
        this.search = null;
        this.items = this.volumes;
        this.volumesKey = new Date().toISOString();
        setTimeout(() => {
          const piecesToPackInput = this.$refs.volumeInput;
          piecesToPackInput.focus();
        }, 100);
      }
    },
    search(val) {
      val && val !== this.currentVolume && this.querySelections(val);
    }
  }
};
</script>
